import { createAsyncThunk } from '@reduxjs/toolkit';
import { RedirectsAPI } from '@/api';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import { REDIRECTS_SLICE_NAME } from './models';
import {
  ICreateRedirectDTO,
  IDeleteRedirectDTO,
  IUpdateRedirectDTO,
  IGetRedirectDTO,
  IGetRedirectResponse,
  IGetRedirectsDTO,
  IGetRedirectsResponse,
} from '@/models/redirects.model';

export const getRedirects = createAsyncThunk<
  IGetRedirectsResponse,
  IGetRedirectsDTO,
  { serializedErrorType: IApiError }
>(
  `${REDIRECTS_SLICE_NAME}/getRedirects`,
  async (data) => {
    const response = await RedirectsAPI.getRedirects(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const createRedirect = createAsyncThunk<
  IGetRedirectResponse,
  ICreateRedirectDTO,
  { serializedErrorType: IApiError }
>(
  `${REDIRECTS_SLICE_NAME}/createRedirect`,
  async (data) => {
    const response = await RedirectsAPI.createRedirect(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const getRedirect = createAsyncThunk<IGetRedirectResponse, IGetRedirectDTO, { serializedErrorType: IApiError }>(
  `${REDIRECTS_SLICE_NAME}/getRedirect`,
  async (data) => {
    const response = await RedirectsAPI.getRedirect(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const updateRedirect = createAsyncThunk<
  IGetRedirectResponse,
  IUpdateRedirectDTO,
  { serializedErrorType: IApiError }
>(
  `${REDIRECTS_SLICE_NAME}/updateRedirect`,
  async (data) => {
    const response = await RedirectsAPI.updateRedirect(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const deleteRedirect = createAsyncThunk<void, IDeleteRedirectDTO, { serializedErrorType: IApiError }>(
  `${REDIRECTS_SLICE_NAME}/deleteRedirect`,
  async (data) => {
    const response = await RedirectsAPI.deleteRedirect(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
